var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3104 14.4998H1.11524C0.500385 14.4998 0 14.0001 0 13.386V1.61381C0 0.999745 0.500385 0.5 1.11524 0.5H11.3104C11.9252 0.5 12.4256 0.999745 12.4256 1.61381V13.3862C12.4256 14.0003 11.9252 14.5 11.3104 14.5V14.4998ZM1.11544 0.867459C0.70336 0.867459 0.368135 1.20226 0.368135 1.61381V13.3862C0.368135 13.7977 0.70336 14.1325 1.11544 14.1325H11.3106C11.7227 14.1325 12.0579 13.7977 12.0579 13.3862V1.61381C12.0579 1.20226 11.7227 0.867459 11.3106 0.867459H1.11544Z",
    fill: "#173CBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21307 3.03241C5.53894 3.03241 4.99072 3.57992 4.99072 4.25319C4.99072 4.87052 5.45145 5.38211 6.0477 5.46275C6.07632 5.46172 6.10514 5.4607 6.13376 5.4607H6.29176C6.32099 5.4607 6.34961 5.46111 6.37823 5.46275C6.97448 5.38211 7.43521 4.87052 7.43521 4.25319C7.43521 3.57992 6.88699 3.03241 6.21286 3.03241H6.21307Z",
    fill: "#173CBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0285 5.96045C5.05553 6.01536 4.28043 6.82296 4.28043 7.80816V9.05997H4.94475V7.50929C4.94475 7.3719 5.05594 7.26085 5.19351 7.26085C5.33107 7.26085 5.44227 7.3719 5.44227 7.50929V9.05997H6.98287V7.50929C6.98287 7.3719 7.09407 7.26085 7.23164 7.26085C7.3692 7.26085 7.4804 7.3719 7.4804 7.50929V9.05997H8.14472V7.80816C8.14472 6.82296 7.37002 6.01516 6.39705 5.96045C6.33675 5.96678 6.27502 5.97025 6.21288 5.97025C6.15074 5.97066 6.08901 5.96739 6.0283 5.96045H6.0285Z",
    fill: "#173CBA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93297 4.253C7.93297 4.82766 7.64864 5.33721 7.21367 5.64893C8.05296 6.00762 8.64247 6.84052 8.64247 7.80837V9.06018H8.68273C9.29207 9.06018 9.78836 8.56473 9.78836 7.95597V3.30189C9.78836 2.69334 9.29227 2.19767 8.68273 2.19767H3.74265V2.19727C3.13332 2.19727 2.63702 2.69272 2.63702 3.30148V7.95617C2.63702 8.56472 3.13312 9.06039 3.74265 9.06039H3.78292V7.80858C3.78292 6.84073 4.37243 6.00782 5.21172 5.64914C4.77674 5.337 4.49241 4.82746 4.49241 4.2532C4.49241 3.30618 5.26425 2.53553 6.21228 2.53553C7.16032 2.53553 7.93277 3.30638 7.93277 4.2532H7.93297V4.253Z",
    fill: "#173CBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4339 11.1271C10.4339 11.2645 10.3231 11.3756 10.1855 11.3756H2.24067C2.10311 11.3756 1.99191 11.2645 1.99191 11.1271C1.99191 10.9897 2.10311 10.8787 2.24067 10.8787H10.1851C10.3227 10.8787 10.4339 10.9897 10.4339 11.1271Z",
    fill: "#173CBA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4339 12.5541C10.4339 12.6915 10.3231 12.8026 10.1855 12.8026H2.24067C2.10311 12.8026 1.99191 12.6915 1.99191 12.5541C1.99191 12.4167 2.10311 12.3057 2.24067 12.3057H10.1851C10.3227 12.3057 10.4339 12.4167 10.4339 12.5541Z",
    fill: "#173CBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.54a66f3268dbbde9ab3caef1353cbcbe.svg";
export { ForwardRef as ReactComponent };